export const data = { content:"{\"openapi\":\"3.1.1\",\"info\":{\"title\":\"Wision Core API\",\"version\":\"1.0.0\"},\"components\":{\"securitySchemes\":{\"apiKey\":{\"type\":\"apiKey\",\"name\":\"Authorization\",\"in\":\"header\"}},\"schemas\":{}},\"paths\":{\"/api/v1/admin/users\":{\"get\":{\"summary\":\"List users\",\"tags\":[\"Admin user\"],\"description\":\"List all users\",\"parameters\":[{\"schema\":{},\"in\":\"query\",\"name\":\"not\"},{\"schema\":{\"type\":\"string\",\"format\":\"email\"},\"in\":\"query\",\"name\":\"email\",\"required\":false},{\"schema\":{\"type\":\"string\"},\"in\":\"query\",\"name\":\"username\",\"required\":false}],\"responses\":{\"200\":{\"description\":\"Default Response\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\"},\"name\":{\"type\":[\"null\",\"string\"]},\"email\":{\"type\":[\"null\",\"string\"]},\"username\":{\"type\":\"string\"},\"phone_number\":{\"type\":[\"null\",\"string\"]},\"language\":{\"type\":\"string\"},\"avatar\":{\"type\":[\"null\",\"string\"]},\"title\":{\"type\":[\"null\",\"string\"]},\"created_at\":{\"anyOf\":[{\"type\":\"string\",\"format\":\"date-time\"},{\"type\":\"null\"}]},\"last_login_at\":{\"anyOf\":[{\"type\":\"string\",\"format\":\"date-time\"},{\"type\":\"null\"}]}},\"required\":[\"id\",\"name\",\"email\",\"username\",\"phone_number\",\"language\",\"avatar\",\"title\",\"created_at\",\"last_login_at\"],\"additionalProperties\":false}}}}}}}},\"/api/v1/admin/users/{id}\":{\"get\":{\"summary\":\"Get single user\",\"tags\":[\"Admin user\"],\"description\":\"Get user\",\"parameters\":[{\"schema\":{\"type\":\"string\"},\"in\":\"path\",\"name\":\"id\",\"required\":true}],\"responses\":{\"200\":{\"description\":\"Default Response\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\"},\"name\":{\"type\":[\"null\",\"string\"]},\"email\":{\"type\":[\"null\",\"string\"]},\"username\":{\"type\":\"string\"},\"phone_number\":{\"type\":[\"null\",\"string\"]},\"language\":{\"type\":\"string\"},\"avatar\":{\"type\":[\"null\",\"string\"]},\"title\":{\"type\":[\"null\",\"string\"]},\"created_at\":{\"anyOf\":[{\"type\":\"string\",\"format\":\"date-time\"},{\"type\":\"null\"}]},\"last_login_at\":{\"anyOf\":[{\"type\":\"string\",\"format\":\"date-time\"},{\"type\":\"null\"}]}},\"required\":[\"id\",\"name\",\"email\",\"username\",\"phone_number\",\"language\",\"avatar\",\"title\",\"created_at\",\"last_login_at\"],\"additionalProperties\":false}}}}}}},\"/api/v1/admin/users/{id}/password\":{\"put\":{\"summary\":\"Update user password\",\"tags\":[\"Admin user\"],\"description\":\"Update the users password\",\"requestBody\":{\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"password\":{\"type\":\"string\",\"minLength\":6}},\"required\":[\"password\"],\"additionalProperties\":false}}},\"required\":true},\"parameters\":[{\"schema\":{\"type\":\"string\"},\"in\":\"path\",\"name\":\"id\",\"required\":true}],\"responses\":{\"204\":{\"description\":\"No content\"}}}},\"/api/v1/admin/organizations\":{\"get\":{\"summary\":\"List organizations\",\"tags\":[\"Admin organization\"],\"description\":\"List all organizations\",\"parameters\":[{\"schema\":{},\"in\":\"query\",\"name\":\"not\"},{\"schema\":{\"type\":\"number\"},\"in\":\"query\",\"name\":\"xtool_id\",\"required\":false}],\"responses\":{\"200\":{\"description\":\"Default Response\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\"},\"name\":{\"type\":[\"null\",\"string\"]},\"email\":{\"type\":[\"null\",\"string\"]},\"language\":{\"type\":\"string\",\"enum\":[\"sv\",\"en\",\"dk\",\"de\",\"da\"]},\"xtool_id\":{\"type\":[\"null\",\"number\"]},\"country\":{\"type\":[\"null\",\"string\"]},\"comments\":{\"type\":[\"null\",\"string\"]},\"contact_person\":{\"type\":[\"null\",\"string\"]},\"parent\":{\"type\":[\"null\",\"string\"]},\"ahlsell_number\":{\"type\":[\"null\",\"string\"]},\"organization_number\":{\"type\":[\"null\",\"string\"]},\"created_at\":{\"anyOf\":[{\"type\":\"string\",\"format\":\"date-time\"},{\"type\":\"null\"}]},\"deleted_at\":{\"anyOf\":[{\"type\":\"string\",\"format\":\"date-time\"},{\"type\":\"null\"}]}},\"required\":[\"id\",\"name\",\"email\",\"language\",\"xtool_id\",\"country\",\"comments\",\"contact_person\",\"parent\",\"ahlsell_number\",\"organization_number\",\"created_at\",\"deleted_at\"],\"additionalProperties\":false}}}}}}}},\"/api/v1/admin/organizations/{id}\":{\"get\":{\"summary\":\"Get organization\",\"tags\":[\"Admin organization\"],\"description\":\"Get single organization\",\"parameters\":[{\"schema\":{\"type\":\"string\"},\"in\":\"path\",\"name\":\"id\",\"required\":true}],\"responses\":{\"200\":{\"description\":\"Default Response\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\"},\"name\":{\"type\":[\"null\",\"string\"]},\"email\":{\"type\":[\"null\",\"string\"]},\"language\":{\"type\":\"string\",\"enum\":[\"sv\",\"en\",\"dk\",\"de\",\"da\"]},\"xtool_id\":{\"type\":[\"null\",\"number\"]},\"country\":{\"type\":[\"null\",\"string\"]},\"comments\":{\"type\":[\"null\",\"string\"]},\"contact_person\":{\"type\":[\"null\",\"string\"]},\"parent\":{\"type\":[\"null\",\"string\"]},\"ahlsell_number\":{\"type\":[\"null\",\"string\"]},\"organization_number\":{\"type\":[\"null\",\"string\"]},\"created_at\":{\"anyOf\":[{\"type\":\"string\",\"format\":\"date-time\"},{\"type\":\"null\"}]},\"deleted_at\":{\"anyOf\":[{\"type\":\"string\",\"format\":\"date-time\"},{\"type\":\"null\"}]}},\"required\":[\"id\",\"name\",\"email\",\"language\",\"xtool_id\",\"country\",\"comments\",\"contact_person\",\"parent\",\"ahlsell_number\",\"organization_number\",\"created_at\",\"deleted_at\"],\"additionalProperties\":false}}}}}},\"patch\":{\"summary\":\"Update organization\",\"tags\":[\"Admin organization\"],\"description\":\"Update organization\",\"requestBody\":{\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\"},\"name\":{\"type\":[\"string\",\"null\"]},\"email\":{\"type\":[\"string\",\"null\"]},\"language\":{\"type\":\"string\",\"enum\":[\"sv\",\"en\",\"dk\",\"de\",\"da\"]},\"xtool_id\":{\"type\":[\"number\",\"null\"]},\"country\":{\"type\":[\"string\",\"null\"]},\"comments\":{\"type\":[\"string\",\"null\"]},\"contact_person\":{\"type\":[\"string\",\"null\"]},\"parent\":{\"type\":[\"string\",\"null\"]},\"ahlsell_number\":{\"type\":[\"string\",\"null\"]},\"organization_number\":{\"type\":[\"string\",\"null\"]},\"created_at\":{\"anyOf\":[{\"type\":\"string\",\"format\":\"date-time\"},{\"type\":\"null\"}]},\"deleted_at\":{\"anyOf\":[{\"type\":\"string\",\"format\":\"date-time\"},{\"type\":\"null\"}]}},\"additionalProperties\":false}}}},\"parameters\":[{\"schema\":{\"type\":\"string\"},\"in\":\"path\",\"name\":\"id\",\"required\":true}],\"responses\":{\"200\":{\"description\":\"Default Response\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\"},\"name\":{\"type\":[\"null\",\"string\"]},\"email\":{\"type\":[\"null\",\"string\"]},\"language\":{\"type\":\"string\",\"enum\":[\"sv\",\"en\",\"dk\",\"de\",\"da\"]},\"xtool_id\":{\"type\":[\"null\",\"number\"]},\"country\":{\"type\":[\"null\",\"string\"]},\"comments\":{\"type\":[\"null\",\"string\"]},\"contact_person\":{\"type\":[\"null\",\"string\"]},\"parent\":{\"type\":[\"null\",\"string\"]},\"ahlsell_number\":{\"type\":[\"null\",\"string\"]},\"organization_number\":{\"type\":[\"null\",\"string\"]},\"created_at\":{\"anyOf\":[{\"type\":\"string\",\"format\":\"date-time\"},{\"type\":\"null\"}]},\"deleted_at\":{\"anyOf\":[{\"type\":\"string\",\"format\":\"date-time\"},{\"type\":\"null\"}]}},\"additionalProperties\":false}}}}}}},\"/api/v1/admin/organizations/{id}/users\":{\"get\":{\"summary\":\"List users in organization\",\"tags\":[\"Admin organization\"],\"description\":\"List all users for organization\",\"parameters\":[{\"schema\":{\"type\":\"string\"},\"in\":\"path\",\"name\":\"id\",\"required\":true}],\"responses\":{\"200\":{\"description\":\"Default Response\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\"},\"name\":{\"type\":[\"null\",\"string\"]},\"email\":{\"type\":[\"null\",\"string\"]},\"username\":{\"type\":\"string\"},\"phone_number\":{\"type\":[\"null\",\"string\"]},\"language\":{\"type\":\"string\"},\"avatar\":{\"type\":[\"null\",\"string\"]},\"title\":{\"type\":[\"null\",\"string\"]},\"created_at\":{\"anyOf\":[{\"type\":\"string\",\"format\":\"date-time\"},{\"type\":\"null\"}]},\"last_login_at\":{\"anyOf\":[{\"type\":\"string\",\"format\":\"date-time\"},{\"type\":\"null\"}]},\"user_group\":{\"type\":\"string\",\"enum\":[\"user\",\"admin\"]}},\"required\":[\"id\",\"name\",\"email\",\"username\",\"phone_number\",\"language\",\"avatar\",\"title\",\"created_at\",\"last_login_at\",\"user_group\"],\"additionalProperties\":false}}}}}}}},\"/api/v1/admin/organizations/{organization_id}/users/{user_id}\":{\"post\":{\"summary\":\"Create user access\",\"tags\":[\"Admin organization\"],\"description\":\"Give access for user to an organization\",\"requestBody\":{\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"user_group\":{\"type\":\"string\",\"enum\":[\"user\",\"admin\"]}},\"required\":[\"user_group\"],\"additionalProperties\":false}}},\"required\":true},\"parameters\":[{\"schema\":{\"type\":\"string\"},\"in\":\"path\",\"name\":\"organization_id\",\"required\":true},{\"schema\":{\"type\":\"string\"},\"in\":\"path\",\"name\":\"user_id\",\"required\":true}],\"responses\":{\"201\":{\"description\":\"Default Response\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"user_group\":{\"type\":\"string\",\"enum\":[\"user\",\"admin\"]}},\"required\":[\"user_group\"],\"additionalProperties\":false}}}}}},\"put\":{\"summary\":\"Update user access\",\"tags\":[\"Admin organization\"],\"description\":\"Update user access for organization\",\"requestBody\":{\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"user_group\":{\"type\":\"string\",\"enum\":[\"user\",\"admin\"]}},\"required\":[\"user_group\"],\"additionalProperties\":false}}},\"required\":true},\"parameters\":[{\"schema\":{\"type\":\"string\"},\"in\":\"path\",\"name\":\"organization_id\",\"required\":true},{\"schema\":{\"type\":\"string\"},\"in\":\"path\",\"name\":\"user_id\",\"required\":true}],\"responses\":{\"200\":{\"description\":\"Default Response\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"user_group\":{\"type\":\"string\",\"enum\":[\"user\",\"admin\"]}},\"required\":[\"user_group\"],\"additionalProperties\":false}}}}}},\"delete\":{\"summary\":\"Delete user access\",\"tags\":[\"Admin organization\"],\"description\":\"Delete user access for organization\",\"parameters\":[{\"schema\":{\"type\":\"string\"},\"in\":\"path\",\"name\":\"organization_id\",\"required\":true},{\"schema\":{\"type\":\"string\"},\"in\":\"path\",\"name\":\"user_id\",\"required\":true}],\"responses\":{\"204\":{\"description\":\"No content\"}}}},\"/openapi.json\":{\"get\":{\"responses\":{\"200\":{\"description\":\"Default Response\"}}}},\"/health\":{\"get\":{\"responses\":{\"200\":{\"description\":\"Default Response\"}}}}},\"servers\":[{\"url\":\"https://core.wision.io\",\"description\":\"API\"}]}",
  parsed:{ openapi:"3.1.1",
    info:{ title:"Wision Core API",
      version:"1.0.0" },
    components:{ securitySchemes:{ apiKey:{ type:"apiKey",
          name:"Authorization",
          "in":"header" } },
      schemas:{} },
    paths:{ "/api/v1/admin/users":{ get:{ summary:"List users",
          tags:[ "Admin user" ],
          description:"List all users",
          parameters:[ { schema:{},
              "in":"query",
              name:"not" },
            { schema:{ type:"string",
                format:"email" },
              "in":"query",
              name:"email",
              required:false },
            { schema:{ type:"string" },
              "in":"query",
              name:"username",
              required:false } ],
          responses:{ 200:{ description:"Default Response",
              content:{ "application/json":{ schema:{ type:"array",
                    items:{ type:"object",
                      properties:{ id:{ type:"string" },
                        name:{ type:[ "null",
                            "string" ] },
                        email:{ type:[ "null",
                            "string" ] },
                        username:{ type:"string" },
                        phone_number:{ type:[ "null",
                            "string" ] },
                        language:{ type:"string" },
                        avatar:{ type:[ "null",
                            "string" ] },
                        title:{ type:[ "null",
                            "string" ] },
                        created_at:{ anyOf:[ { type:"string",
                              format:"date-time" },
                            { type:"null" } ] },
                        last_login_at:{ anyOf:[ { type:"string",
                              format:"date-time" },
                            { type:"null" } ] } },
                      required:[ "id",
                        "name",
                        "email",
                        "username",
                        "phone_number",
                        "language",
                        "avatar",
                        "title",
                        "created_at",
                        "last_login_at" ],
                      additionalProperties:false } } } } } } } },
      "/api/v1/admin/users/{id}":{ get:{ summary:"Get single user",
          tags:[ "Admin user" ],
          description:"Get user",
          parameters:[ { schema:{ type:"string" },
              "in":"path",
              name:"id",
              required:true } ],
          responses:{ 200:{ description:"Default Response",
              content:{ "application/json":{ schema:{ type:"object",
                    properties:{ id:{ type:"string" },
                      name:{ type:[ "null",
                          "string" ] },
                      email:{ type:[ "null",
                          "string" ] },
                      username:{ type:"string" },
                      phone_number:{ type:[ "null",
                          "string" ] },
                      language:{ type:"string" },
                      avatar:{ type:[ "null",
                          "string" ] },
                      title:{ type:[ "null",
                          "string" ] },
                      created_at:{ anyOf:[ { type:"string",
                            format:"date-time" },
                          { type:"null" } ] },
                      last_login_at:{ anyOf:[ { type:"string",
                            format:"date-time" },
                          { type:"null" } ] } },
                    required:[ "id",
                      "name",
                      "email",
                      "username",
                      "phone_number",
                      "language",
                      "avatar",
                      "title",
                      "created_at",
                      "last_login_at" ],
                    additionalProperties:false } } } } } } },
      "/api/v1/admin/users/{id}/password":{ put:{ summary:"Update user password",
          tags:[ "Admin user" ],
          description:"Update the users password",
          requestBody:{ content:{ "application/json":{ schema:{ type:"object",
                  properties:{ password:{ type:"string",
                      minLength:6 } },
                  required:[ "password" ],
                  additionalProperties:false } } },
            required:true },
          parameters:[ { schema:{ type:"string" },
              "in":"path",
              name:"id",
              required:true } ],
          responses:{ 204:{ description:"No content" } } } },
      "/api/v1/admin/organizations":{ get:{ summary:"List organizations",
          tags:[ "Admin organization" ],
          description:"List all organizations",
          parameters:[ { schema:{},
              "in":"query",
              name:"not" },
            { schema:{ type:"number" },
              "in":"query",
              name:"xtool_id",
              required:false } ],
          responses:{ 200:{ description:"Default Response",
              content:{ "application/json":{ schema:{ type:"array",
                    items:{ type:"object",
                      properties:{ id:{ type:"string" },
                        name:{ type:[ "null",
                            "string" ] },
                        email:{ type:[ "null",
                            "string" ] },
                        language:{ type:"string",
                          "enum":[ "sv",
                            "en",
                            "dk",
                            "de",
                            "da" ] },
                        xtool_id:{ type:[ "null",
                            "number" ] },
                        country:{ type:[ "null",
                            "string" ] },
                        comments:{ type:[ "null",
                            "string" ] },
                        contact_person:{ type:[ "null",
                            "string" ] },
                        parent:{ type:[ "null",
                            "string" ] },
                        ahlsell_number:{ type:[ "null",
                            "string" ] },
                        organization_number:{ type:[ "null",
                            "string" ] },
                        created_at:{ anyOf:[ { type:"string",
                              format:"date-time" },
                            { type:"null" } ] },
                        deleted_at:{ anyOf:[ { type:"string",
                              format:"date-time" },
                            { type:"null" } ] } },
                      required:[ "id",
                        "name",
                        "email",
                        "language",
                        "xtool_id",
                        "country",
                        "comments",
                        "contact_person",
                        "parent",
                        "ahlsell_number",
                        "organization_number",
                        "created_at",
                        "deleted_at" ],
                      additionalProperties:false } } } } } } } },
      "/api/v1/admin/organizations/{id}":{ get:{ summary:"Get organization",
          tags:[ "Admin organization" ],
          description:"Get single organization",
          parameters:[ { schema:{ type:"string" },
              "in":"path",
              name:"id",
              required:true } ],
          responses:{ 200:{ description:"Default Response",
              content:{ "application/json":{ schema:{ type:"object",
                    properties:{ id:{ type:"string" },
                      name:{ type:[ "null",
                          "string" ] },
                      email:{ type:[ "null",
                          "string" ] },
                      language:{ type:"string",
                        "enum":[ "sv",
                          "en",
                          "dk",
                          "de",
                          "da" ] },
                      xtool_id:{ type:[ "null",
                          "number" ] },
                      country:{ type:[ "null",
                          "string" ] },
                      comments:{ type:[ "null",
                          "string" ] },
                      contact_person:{ type:[ "null",
                          "string" ] },
                      parent:{ type:[ "null",
                          "string" ] },
                      ahlsell_number:{ type:[ "null",
                          "string" ] },
                      organization_number:{ type:[ "null",
                          "string" ] },
                      created_at:{ anyOf:[ { type:"string",
                            format:"date-time" },
                          { type:"null" } ] },
                      deleted_at:{ anyOf:[ { type:"string",
                            format:"date-time" },
                          { type:"null" } ] } },
                    required:[ "id",
                      "name",
                      "email",
                      "language",
                      "xtool_id",
                      "country",
                      "comments",
                      "contact_person",
                      "parent",
                      "ahlsell_number",
                      "organization_number",
                      "created_at",
                      "deleted_at" ],
                    additionalProperties:false } } } } } },
        patch:{ summary:"Update organization",
          tags:[ "Admin organization" ],
          description:"Update organization",
          requestBody:{ content:{ "application/json":{ schema:{ type:"object",
                  properties:{ id:{ type:"string" },
                    name:{ type:[ "string",
                        "null" ] },
                    email:{ type:[ "string",
                        "null" ] },
                    language:{ type:"string",
                      "enum":[ "sv",
                        "en",
                        "dk",
                        "de",
                        "da" ] },
                    xtool_id:{ type:[ "number",
                        "null" ] },
                    country:{ type:[ "string",
                        "null" ] },
                    comments:{ type:[ "string",
                        "null" ] },
                    contact_person:{ type:[ "string",
                        "null" ] },
                    parent:{ type:[ "string",
                        "null" ] },
                    ahlsell_number:{ type:[ "string",
                        "null" ] },
                    organization_number:{ type:[ "string",
                        "null" ] },
                    created_at:{ anyOf:[ { type:"string",
                          format:"date-time" },
                        { type:"null" } ] },
                    deleted_at:{ anyOf:[ { type:"string",
                          format:"date-time" },
                        { type:"null" } ] } },
                  additionalProperties:false } } } },
          parameters:[ { schema:{ type:"string" },
              "in":"path",
              name:"id",
              required:true } ],
          responses:{ 200:{ description:"Default Response",
              content:{ "application/json":{ schema:{ type:"object",
                    properties:{ id:{ type:"string" },
                      name:{ type:[ "null",
                          "string" ] },
                      email:{ type:[ "null",
                          "string" ] },
                      language:{ type:"string",
                        "enum":[ "sv",
                          "en",
                          "dk",
                          "de",
                          "da" ] },
                      xtool_id:{ type:[ "null",
                          "number" ] },
                      country:{ type:[ "null",
                          "string" ] },
                      comments:{ type:[ "null",
                          "string" ] },
                      contact_person:{ type:[ "null",
                          "string" ] },
                      parent:{ type:[ "null",
                          "string" ] },
                      ahlsell_number:{ type:[ "null",
                          "string" ] },
                      organization_number:{ type:[ "null",
                          "string" ] },
                      created_at:{ anyOf:[ { type:"string",
                            format:"date-time" },
                          { type:"null" } ] },
                      deleted_at:{ anyOf:[ { type:"string",
                            format:"date-time" },
                          { type:"null" } ] } },
                    additionalProperties:false } } } } } } },
      "/api/v1/admin/organizations/{id}/users":{ get:{ summary:"List users in organization",
          tags:[ "Admin organization" ],
          description:"List all users for organization",
          parameters:[ { schema:{ type:"string" },
              "in":"path",
              name:"id",
              required:true } ],
          responses:{ 200:{ description:"Default Response",
              content:{ "application/json":{ schema:{ type:"array",
                    items:{ type:"object",
                      properties:{ id:{ type:"string" },
                        name:{ type:[ "null",
                            "string" ] },
                        email:{ type:[ "null",
                            "string" ] },
                        username:{ type:"string" },
                        phone_number:{ type:[ "null",
                            "string" ] },
                        language:{ type:"string" },
                        avatar:{ type:[ "null",
                            "string" ] },
                        title:{ type:[ "null",
                            "string" ] },
                        created_at:{ anyOf:[ { type:"string",
                              format:"date-time" },
                            { type:"null" } ] },
                        last_login_at:{ anyOf:[ { type:"string",
                              format:"date-time" },
                            { type:"null" } ] },
                        user_group:{ type:"string",
                          "enum":[ "user",
                            "admin" ] } },
                      required:[ "id",
                        "name",
                        "email",
                        "username",
                        "phone_number",
                        "language",
                        "avatar",
                        "title",
                        "created_at",
                        "last_login_at",
                        "user_group" ],
                      additionalProperties:false } } } } } } } },
      "/api/v1/admin/organizations/{organization_id}/users/{user_id}":{ post:{ summary:"Create user access",
          tags:[ "Admin organization" ],
          description:"Give access for user to an organization",
          requestBody:{ content:{ "application/json":{ schema:{ type:"object",
                  properties:{ user_group:{ type:"string",
                      "enum":[ "user",
                        "admin" ] } },
                  required:[ "user_group" ],
                  additionalProperties:false } } },
            required:true },
          parameters:[ { schema:{ type:"string" },
              "in":"path",
              name:"organization_id",
              required:true },
            { schema:{ type:"string" },
              "in":"path",
              name:"user_id",
              required:true } ],
          responses:{ 201:{ description:"Default Response",
              content:{ "application/json":{ schema:{ type:"object",
                    properties:{ user_group:{ type:"string",
                        "enum":[ "user",
                          "admin" ] } },
                    required:[ "user_group" ],
                    additionalProperties:false } } } } } },
        put:{ summary:"Update user access",
          tags:[ "Admin organization" ],
          description:"Update user access for organization",
          requestBody:{ content:{ "application/json":{ schema:{ type:"object",
                  properties:{ user_group:{ type:"string",
                      "enum":[ "user",
                        "admin" ] } },
                  required:[ "user_group" ],
                  additionalProperties:false } } },
            required:true },
          parameters:[ { schema:{ type:"string" },
              "in":"path",
              name:"organization_id",
              required:true },
            { schema:{ type:"string" },
              "in":"path",
              name:"user_id",
              required:true } ],
          responses:{ 200:{ description:"Default Response",
              content:{ "application/json":{ schema:{ type:"object",
                    properties:{ user_group:{ type:"string",
                        "enum":[ "user",
                          "admin" ] } },
                    required:[ "user_group" ],
                    additionalProperties:false } } } } } },
        "delete":{ summary:"Delete user access",
          tags:[ "Admin organization" ],
          description:"Delete user access for organization",
          parameters:[ { schema:{ type:"string" },
              "in":"path",
              name:"organization_id",
              required:true },
            { schema:{ type:"string" },
              "in":"path",
              name:"user_id",
              required:true } ],
          responses:{ 204:{ description:"No content" } } } },
      "/openapi.json":{ get:{ responses:{ 200:{ description:"Default Response" } } } },
      "/health":{ get:{ responses:{ 200:{ description:"Default Response" } } } } },
    servers:[ { url:"https://core.wision.io",
        description:"API" } ] } }